export const regex = {
  facebook: /^(?:https?:\/\/)?(?:www\.|m\.|touch\.)?(?:facebook\.com|fb(?:\.me|\.com))\/(?!$)(?:(?:\w)*#!\/)?(?:pages\/)?(?:photo\.php\?fbid=)?(?:[\w-]*\/)*?(?:\/)?(?:profile\.php\?id=)?([^/?\s]*)(?:\/|&|\?)?.*$/,
  instagram: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/([A-Za-z0-9-_.]+)/im,
  urlProtocols: /^(https?:|)\/\//,
  removeAfterFirstSlash: /\/.*$/,
  timeFormat: /^(0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/
};
